<template>
  <div class="colorPicker" :style="`width: ${width}px; height: ${height}px;`">
    <div
      class="transparent"
      :style="`width: ${width}px; height: ${height}px;`"
    ></div>
    <settings-button
      @click="toggleComponent"
      class="color"
      :style="getColorStyles"
    ></settings-button>
    <Chrome v-show="colorPickerOpen" v-model="colors" />
  </div>
</template>

<script>
import { Chrome } from "vue-color";
import CloseComponent from "@/mixins/CloseComponent";
import SettingsButton from "../../../BaseComponents/SettingsButton";
export default {
  name: "ColorPicker",

  mixins: [CloseComponent],

  props: {
    default: String,
    width: {
      type: Number,
      default: 55,
    },
    height: {
      type: Number,
      default: 55,
    },
  },
  components: {
    SettingsButton,
    Chrome,
  },
  data() {
    return {
      colors: "",
    };
  },
  computed: {
    colorPickerOpen() {
      /* just renaming from CloseComponent mixin */
      return this.componentOpen;
    },
    getColorStyles() {
      let styles = `width: ${this.width}px; height: ${this.height}px;`;
      if (this.colors) {
        styles = styles + " " + `background-color:${this.colors.hex8};`;
      }
      return styles;
    },
  },
  watch: {
    colors: {
      handler() {
        this.$emit("updateColor", this.colors.hex8);
      },
      deep: true,
    },
  },
};
</script>

<style >
.colorPicker {
  position: relative;
  margin-top: 15px;
}
.colorPicker .color {
  box-sizing: border-box;
  padding: 15px;
  padding-bottom: 5px;
  border-radius: 360px;
  box-shadow: 0px -1px 4px 0px #d8d8d8ab, 0px 1px 4px 0px #cacaca9e;
  border: 2px solid transparent;
  z-index: 5;
  position: absolute;
  top: 0px;
  left: 0px;
  margin-top: 0px !important;
}
.colorPicker .transparent {
  position: absolute;
  z-index: 1;
  top: 0px;
  left: 0px;
  box-sizing: border-box;
  padding: 15px;
  padding-bottom: 5px;
  border-radius: 360px;
  border: 2px solid #eaeaea;
  background-image: linear-gradient(45deg, #ddd 25%, transparent 25%),
    linear-gradient(-45deg, #ddd 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, #ddd 75%),
    linear-gradient(-45deg, transparent 75%, #ddd 75%);
  background-size: 10px 10px;
  background-position: 0 0, 0 5px, 5px -5px, -5px 0px;
}
.vc-chrome {
  background: #fff !important;
  border-radius: 6px !important;
  box-shadow: 0px 3px 4px 0px #d8d8d885, 3px 0px 4px 0px #d6d6d685,
    0px -2px 4px 0px #d8d8d885 !important;
  box-sizing: initial !important;
  width: 225px !important;
  font-family: Menlo !important;
  background-color: #fff !important;
  position: absolute !important;
  top: 66px !important;
  left: 0px !important;
  z-index: 10 !important;
}

.vc-chrome .vc-chrome-body {
  padding: 16px 16px 12px;
  background-color: #fff;
  border-radius: 6px;
}

.vc-chrome .vc-chrome-saturation-wrap {
  width: 100%;
  padding-bottom: 55%;
  position: relative;
  overflow: hidden;
  border-radius: 6px 6px 0px 0px;
}
</style>